<div id="notfound">
    <div class="notfound">
        <div class="notfound-404">
            <h1 style="background-image: url('assets/img/system/404.png')">404</h1>
        </div>
        <h2>Oops! Die Seite konnte nicht gefunden werden.</h2>
        <p>Entschuldigung, aber die gesuchte Seite existiert nicht oder wurde entfernt.</p>
    </div>
</div>
